export default __webpack_public_path__ + "static/media/7.de1fb9cc.jpg";